import { IsNumber, IsOptional, IsString } from "class-validator";

import { IIncentiveParamsAllOfferedClasses } from "./incentive-params-all-offered-classes.interface";

export class IncentiveParamsAllOfferedClassesDto
  implements IIncentiveParamsAllOfferedClasses
{
  @IsOptional()
  @IsString()
  show_type?: string;

  @IsNumber()
  deduction: number;

  @IsOptional()
  @IsNumber()
  junior_deduction?: number;
}
